import {Box, Stack} from '@primer/react-brand/esm'

import {Lede} from '../../components/Lede/Lede'
import {ContentfulProse} from '@github-ui/swp-core/components/contentful/ContentfulProse'
import {People} from '../../components/People/People'
import {SocialShare} from '../../components/SocialShare/SocialShare'
import {Tags} from './Tags'
import type {ResourceDetailsPage} from '../../lib/types/contentful'

type ContentProps = {
  component: ResourceDetailsPage
  indexPath: string
  socialShareUrl: string
}

export default function Content({component, indexPath, socialShareUrl}: ContentProps) {
  const {body, lede, people, peopleLabel, tagsLabel, tags} = component.fields

  return (
    <>
      <Stack padding="none">
        {lede ? (
          <Box marginBlockEnd={{narrow: 24, wide: 48}}>
            <header>
              <Lede content={lede} />
            </header>
          </Box>
        ) : null}

        <Box
          paddingBlockEnd={{narrow: 40, wide: 64}}
          borderBlockEndWidth="thin"
          borderColor="muted"
          borderStyle="solid"
        >
          {body ? <ContentfulProse variant="editorial" component={body} /> : null}
        </Box>
      </Stack>
      {people && people.length > 0 ? (
        <Box
          paddingBlockStart={40}
          paddingBlockEnd={40}
          borderBlockStartWidth="thin"
          borderBlockEndWidth="thin"
          borderColor="muted"
          borderStyle="solid"
        >
          <People label={peopleLabel || ''} people={people} />
        </Box>
      ) : null}
      <Box
        paddingBlockStart={40}
        paddingBlockEnd={40}
        borderBlockStartWidth="thin"
        borderBlockEndWidth="thin"
        borderColor="muted"
        borderStyle="solid"
      >
        <SocialShare url={socialShareUrl} />
      </Box>
      {tagsLabel && (tags?.length ?? 0) > 0 ? (
        <Tags tagsLabel={tagsLabel} indexPath={indexPath} tags={tags || []} />
      ) : null}
    </>
  )
}
